import type { FC } from "react"

import { PaymentTermsDisplay } from "./PaymentTermsDisplay"

import type { CompanyAccountingTerm } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

interface Props {
  customerPaymentTerm?: CompanyAccountingTerm
}

export const CustomerCreditLimitItem: FC<Props> = ({ customerPaymentTerm }) => {
  return (
    <PaymentTermsDisplay
      name='Customer Credit Limit'
      value={customerPaymentTerm?.creditLimit ? `$${formatNumber(customerPaymentTerm.creditLimit)}` : ""}
    />
  )
}
